import React, {useEffect, useState} from 'react';
import {Alert} from 'react-bootstrap';

function QLIAlert(props) {
  const [show, setShow] = useState(true);
  
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => setShow(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [show]);
  
  return (
    <Alert className="qli-alert" variant={props.variant}
           show={show} onClose={() => setShow(false)} dismissible
    >
      <strong>{props.message}</strong>
    </Alert>
  );
}

export default QLIAlert;
